import React, { Component } from 'react'
import { connect } from 'react-redux'
import CatalogEstimateForm from './catalog-estimate-form'
import { Drawer } from 'antd'

import { setShowEstimate } from '../../actions'
import { withTranslation } from 'react-i18next'

class CatalogEstimate extends Component {
  // constructor(props) {
  //   super(props);
  // }

  handleOnClose = () => {
    this.props.setShowEstimate(false)
  }

  render() {
    const { showEstimate, isMobile, t } = this.props

    return (
      <Drawer
        className='cart-drawer'
        open={showEstimate}
        title={t('Quotation')}
        placement='right'
        closable={true}
        onClose={this.handleOnClose}
      >
        <CatalogEstimateForm isMobile={isMobile} />
      </Drawer>
    )
  }
}

const mapStateToProps = ({ catalog }) => {
  return {
    showEstimate: catalog.showEstimate,
  }
}

export default connect(mapStateToProps, { setShowEstimate })(withTranslation()(CatalogEstimate))
